import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import {
  faTrashAlt,
} from "@fortawesome/free-regular-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
// import Image1 from '../../../assets/images/product.png';
import "./style.scss";
import {
  useGetWishlistQuery,
  useAddToCartMutation,
  useRemoveFromWishlistMutation,
} from "../../../services/AddToCartAPI";
import { Link , useNavigate} from "react-router-dom";
import { useGetColorThemeQuery } from "../../../services/commonAPI";
import { useGetCartCountQuery } from "../../../services/cartPageAPI";
import QuickView from "../quick-view-product"
import Loader from "../fullPageLoader"

function Index() {
  const { data, error, isLoading, isSuccess, refetch } = useGetWishlistQuery();
  const [showAddToCartMessage, seShowAddToCartMessage] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState({});
  const [addToCart] = useAddToCartMutation();
  const [showWishListMessage, seShowWishListMessage] = useState(false);
  const [removeFromWishlist] = useRemoveFromWishlistMutation(); // RTK Query mutation

  const [isOpenQuickViewModal, setHandleShowQuickViewModal] = useState(false);
  const [quickViewId, setQuickViewId] = useState("")
const navigate = useNavigate();
  const {
    data: colorthemeData,
  } = useGetColorThemeQuery();


  const {
    refetch: refetchCartCountData
  } = useGetCartCountQuery();

  useEffect(() => {
    refetch();
  }, [refetch]);

  console.log(isWishlisted);

  const handleAddToCart = async (product) => {
    const accessToken = localStorage.getItem("access_token");
    const hasVariants = product.variants && product.variants.length > 0;
    console.log("Has Variants:", hasVariants);

    if (hasVariants) {
      navigate(`/product-detail/${product.id}`);
    }
    else{
      const attributeId = product.attributes && product.attributes.length > 0 ? product.attributes[0].id : null;
      const payload = {
        product_id: product.id,
        quantity: 1,
        product_attribute_id: attributeId
      };
  
      // Add user_id only if the user is logged in
      if (accessToken) {
        payload.user_id = localStorage.getItem("gridMarker");
      }
  
      try {
        const response = await addToCart(payload).unwrap();
  
        // If the user is a guest and a cart token is returned, store it in localStorage
        if (!accessToken && response.guest_cart_token) {
          localStorage.setItem("cartToken", response.guest_cart_token);
        }
        if (response) {
          seShowAddToCartMessage(response.message);
          refetchCartCountData();
        }
      } catch (err) {
        seShowAddToCartMessage(err?.data?.message);
      }
    }
    
  };

  const handleCloseAddCartToast = () => {
    seShowAddToCartMessage(false);
  };

  const handleWishlistToggle = async (e, product) => {
    e.preventDefault(); // Prevent link navigation
    const accessToken = localStorage.getItem("access_token");

    const payload = {
      product_id: product.id,
      // user_id: accessToken ? localStorage.getItem("gridMarker") : null,
    };

    if (accessToken) {
      payload.user_id = localStorage.getItem("gridMarker");
    }

    try {
      const response = await removeFromWishlist(payload).unwrap();
      setIsWishlisted((prev) => ({ ...prev, [product.id]: false }));
      seShowWishListMessage(response.message);
      refetch();
      refetchCartCountData();
    } catch (err) {
      console.error("Failed to update wishlist:", err);
      seShowWishListMessage(err?.data?.message);
    }
  };

  const handleCloseWishListToast = () => {
    seShowWishListMessage(false);
  };

  const handleShowQuickView = (id) => {
    setHandleShowQuickViewModal(true)
    setQuickViewId(id)
  }
  const handlecloseQuikViewMOdal = () => {
    setHandleShowQuickViewModal(false)
  }

  if (isLoading) return <Loader />;
  if (error) return <p>Failed to load Data.</p>;

  return (
    <div className="container">
      <div className="wishlist-page">
        {showAddToCartMessage && (
          <div className="row mb-4 justify-content-center">
            <div className="col-md-5 col-sm-12 -col-lg-5">
              <div className="d-flex toast-message-add-to-cart">
                <p>{showAddToCartMessage}</p>
                {isSuccess && (
                  <Link to="/cart-page">
                    <p className="primary-button-link">View Cart Page</p>
                  </Link>
                )}
                <FontAwesomeIcon
                  icon={faClose}
                  onClick={handleCloseAddCartToast}
                  className="toast-close"
                />
              </div>
            </div>
          </div>
        )}

        {showWishListMessage && (
          <div className="row mb-4 justify-content-center">
            <div className="col-md-5 col-sm-12 -col-lg-5">
              <div className="d-flex toast-message-add-to-wishlist">
                <p>{showWishListMessage}</p>

                <FontAwesomeIcon
                  icon={faClose}
                  onClick={handleCloseWishListToast}
                  className="toast-close"
                />
              </div>
            </div>
          </div>
        )}

        <div className="row">
          {data?.data?.length > 0 ? (
            data?.data?.map((product) => (
              <div className="col-md-3 col-sm-12 col-lg-3" key={product?.id}>
                <div className="wishlist-card">
                  <Link to={`/product-detail/${product?.product?.id}`}>
                    <p
                      className="text-end fa-delete"
                      onClick={(e) =>
                        handleWishlistToggle(e, product?.product)
                      }
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </p>
                    {product?.product?.is_new === 1 && (
                      <div className="new-tag">New</div>
                    )}
                    {product?.product?.discount_details?.discount_percentage > 0 && (
                      <div className="discount-tag" style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}>
                        {Math.round(product?.product?.discount_details?.discount_percentage)}%
                      </div>
                    )}
                    {product?.product?.is_hot === 1 && (
                      <div className="hot-tag">hot</div>
                    )}
                    <div className="wish-list-product-img">
                      <img
                        src={product?.product?.product_main_image_url_large}
                        alt="wishlist-img"
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>

                    <div className="product-details">
                      <p
                        className="product-name"
                        style={{
                          color:
                            colorthemeData?.color_themes?.[0]?.heading_color || "#000",
                        }}
                        title={product?.product?.product_name}
                      >
                        {product?.product?.product_name.length > 20
                          ? `${product?.product?.product_name.substring(0, 30)}...`
                          : product?.product?.product_name}
                      </p>
                      {product?.product?.total_stock === 0 && <p className="out-of-stock-text p-0 m-0">(Out of Stock)</p>}
                      {/* <p className="product-category" style={{ color: colorthemeData?.color_themes?.[0]?.text_color_one || "#a5a5a5" }}>
                        {product?.product?.category?.category_name}
                      </p> */}

                      <p className="product-rate" style={{ color: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}>
                        {product?.product?.product_price !== product?.product?.selling_price && <span style={{ color: colorthemeData?.color_themes?.[0]?.text_color_one }} className="discount-price">${product?.product?.product_price}</span>} ${product?.product?.selling_price}
                      </p>
                    </div>

                    <div className="hover-actions">
                      {product?.product?.attributes?.[0]?.stock > 0 && <p
                        title="Add to Cart"
                        onClick={(e) => {
                          e.preventDefault(); // Prevent link navigation
                          handleAddToCart(product?.product);
                        }}
                      >
                        <FontAwesomeIcon icon={faCartPlus} />
                      </p>}

                      <Link
                        onClick={() => handleShowQuickView(product?.product.id)}
                        title="View Details"
                      >
                        <p><FontAwesomeIcon icon={faEye} /></p>
                      </Link>
                    </div>
                  </Link>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center w-100">
              <h4>There are no products on the Wishlist!</h4>
            </div>
          )}
        </div>
      </div>
      {isOpenQuickViewModal && <QuickView isOpenQuickViewModal={isOpenQuickViewModal} handlecloseQuikViewMOdal={handlecloseQuikViewMOdal} quickViewId={quickViewId} />}
    </div>
  );
}

export default Index;
